<template lang="pug">

  transition(name="fade")
    #swipeup(@click="onClick")
      swipe-up-cta

</template>

<script>


import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap' 
import SwipeUpCta from '@/components/swipecta'

export default {

  name: 'swipeup',
  
  components: {
    SwipeUpCta
  },
  
  data() {
    return { 
    }
  },
  
  computed: {
    ...mapState('app', ['loading'])
  },
  
  mounted() { 
  },
  
  beforeDestroy() {},
  
  methods: {
    onClick() {
      //this.$router.replace({ name: 'intro' });
    }
  },
  
  watch: { 
    'loading.completed'(val){
      if(val){ 
      }
    }
  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#swipeup
  +full()
  +flex-center() 
</style>







